
export default function trackOptimizelySubmit(source) {
  window.optimizely = window.optimizely || [];
  window.optimizely.push(["trackEvent", "submit:" + source]);
}

export function trackOptimizelyOpen(source) {
  window.optimizely = window.optimizely || [];
  window.optimizely.push(["trackEvent", "open:" + source]);
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/tracking/optimizely.js
 **/